// import vue from 'vue'
import { createStore } from 'vuex'
// import axios from 'axios'
// import apiInternational from '@/config/apiInternational.js'

export default createStore({
   state: {
      allLanguages: '',
      allCountries: '',
      allCurrencies: '',

      SelectLanguage: {
         code: '',
         flag: '',
         language: ''
      },

      profile: {},
      statusLogin: false,
      phases: '',
      phaseCurrent: ''
   },
   
   mutations: {
      allLanguages(state, value){
         state.allLanguages = value
      },
      allCountries(state, value){
         state.allCountries = value
      },
      allCurrencies(state, value){
         state.allCurrencies = value
      },
      preLanguage(state,code){
         state.SelectLanguage.code = code
      },
      preLanguageFlag(state,flag){
         state.SelectLanguage.flag = flag
      },
      preLanguageName(state,language){
         state.SelectLanguage.language = language
      },
      changeLanguage(state, value){
         state.SelectLanguage = value
      },
      errorLogin(state, value){
         state.statusLogin = value
      },
      profile(state, value){
         state.profile = value
      },
      loginStatus(state, value){
         state.statusLogin = value
      },
      validatePhoneNumber(state, value){
         state.profile.profile_phone_number_verified = value
      },
      phases(state, value){
         state.phases = value
      },
      phaseCurrent(state, value){
         state.phaseCurrent = value
      }
   },
   actions: {
      // test ({commit}){
      //    return axios.get(api('api/v1/platform/language/dne_international')).then((result) => {
      //       commit('changeLanguage',result.data)
      //    })
      // }
        
   },
   modules: {
      
   },
   getters: {
      
   }
})
